export const SCOPE = 'summaryWidgets';
export const RESET = `${SCOPE}/RESET`;
export const SET_SUMMARY_WIDGETS = `${SCOPE}/SET_SUMMARY_WIDGETS`;
